import api from "./api";

// Portal notification feed for the current user (BFF: GET api/notifications, backed by
// notifications-service). Returns [{ id, type, title, subtitle, url, status, createdOn, readOn }].
async function getPortalNotifications({ status, skip = 0, take = 20, signal } = {}) {
  const { data } = await api.get("api/notifications", {
    params: { status, skip, take },
    signal,
    bypassInterceptor: true,
  });
  return data;
}

async function getUnreadCount({ signal } = {}) {
  const { data } = await api.get("api/notifications/unread-count", {
    signal,
    bypassInterceptor: true,
  });
  return data;
}

async function markNotificationRead(id) {
  const { data } = await api.put(`api/notifications/${id}/read`, {}, { bypassInterceptor: true });
  return data;
}

async function markAllNotificationsRead() {
  const { data } = await api.put("api/notifications/read-all", {}, { bypassInterceptor: true });
  return data;
}

export {
  getPortalNotifications,
  getUnreadCount,
  markNotificationRead,
  markAllNotificationsRead,
};
